import React, { useState, useRef } from "react";
import { createPortal } from "react-dom";

function HoverImagePill({ label, imageUrl }) {
  const [isHover, setIsHover] = useState(false);
  const [pillRectState, setPillRectState] = useState(null);
  const pillRef = useRef(null);

  // When entering the pill, store its position and show the preview
  const handleMouseEnterPill = () => {
    const rect = pillRef.current?.getBoundingClientRect();
    setPillRectState(rect);
    setIsHover(true);
  };

  // If there's no imageUrl, hide the preview as soon as we leave the pill.
  // Otherwise, do nothing (original logic so we can hover on the preview).
  const handleMouseLeavePill = () => {
    if (!imageUrl) {
      setIsHover(false);
      setPillRectState(null);
    }
  };

  const handleMouseEnterPreview = () => {
    setIsHover(true);
  };

  // Hide the preview when leaving the preview itself
  const handleMouseLeavePreview = () => {
    setIsHover(false);
    setPillRectState(null);
  };

  // If the user clicks the pill, open the image in a new tab (only if imageUrl exists)
  const handleClickPill = () => {
    if (imageUrl) window.open(imageUrl, "_blank");
  };

  // Make the preview closer to the pill (reduce the offset from 240 -> 60)
  const previewStyle = pillRectState
    ? {
        position: "fixed",
        top: pillRectState.top - 60,
        left: pillRectState.left + pillRectState.width / 2,
        transform: "translateX(-50%)",
        backgroundColor: "#fff",
        padding: "8px",
        borderRadius: "6px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
        zIndex: 9999,
      }
    : {};

  return (
    <>
      {/* The Pill */}
      <div
        ref={pillRef}
        style={{
          display: "inline-block",
          padding: "5px 10px",
          backgroundColor: "#EFF6FF",
          borderRadius: "12px",
          margin: "5px",
          fontSize: "12px",
          border: "1px solid #A3A3A3",
          cursor: imageUrl ? "pointer" : "default",
          color: "#2A6DCB",
          fontWeight: "bold",
        }}
        onMouseEnter={handleMouseEnterPill}
        onMouseLeave={handleMouseLeavePill}
        onClick={handleClickPill}
        title={imageUrl ? "Click to open screenshot" : undefined}
      >
        {label}
      </div>

      {/* The Preview */}
      {isHover
        ? createPortal(
            <div
              style={previewStyle}
              // Only allow hovering on the preview if an image is actually present
              onMouseEnter={imageUrl ? handleMouseEnterPreview : undefined}
              onMouseLeave={imageUrl ? handleMouseLeavePreview : undefined}
            >
              {imageUrl ? (
                <img
                  src={imageUrl}
                  alt="preview"
                  style={{
                    maxWidth: "480px",
                    height: "auto",
                    cursor: "pointer", // Looks clickable if there's an image
                  }}
                  // Clicking the preview image also opens in a new tab
                  onClick={() => window.open(imageUrl, "_blank")}
                />
              ) : (
                <div
                  style={{
                    backgroundColor: "#fff",
                    borderRadius: "6px",
                    padding: "8px 12px",
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                    color: "#333",
                  }}
                >
                  No screenshot available
                </div>
              )}
            </div>,
            document.body
          )
        : null}
    </>
  );
}

export default HoverImagePill;
